import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDetached(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M2.5 3.5V8.5" stroke="#B8B8B8" />
      <path d="M2.5 3.5V4C2.5 5.10457 3.39543 6 4.5 6H7.5C8.60457 6 9.5 6.89543 9.5 8V8.5" stroke="#616161" />
      <path d="M1.5 3.5H3.5V1.5H1.5V3.5Z" fill="currentColor" stroke="currentColor" />
      <path d="M1.5 10.5H3.5V8.5H1.5V10.5Z" fill="#F5F5F5" stroke="#B8B8B8" />
      <path d="M8.5 10.5H10.5V8.5H8.5V10.5Z" stroke="#616161" />
    </SVGIcon>
  );
}
